let environmentVariablesMap = {};

export const initEnvironmentVariables = async () => {
    const response = await fetch(`/environment.json?version=${Date.now()}`, {
        cache: "no-store",
    });

    if (!response.ok) {
        throw new Error("Failed to load environment.json");
    }

    environmentVariablesMap = await response.json();
};

export const getEnvironmentVariable = (name) => environmentVariablesMap[name];
